let layout = null

export const setLayout = (l) => {
  layout = l
}

export const getLayout = () => layout
